import styled from 'styled-components'

const PageStyle = styled.main.attrs((props) => ({}))`
	
`
export default PageStyle
